<template>
	<div class="container-fluid" v-show="lastorder.length > 0">
		<div class="border-top pt-2"></div>
		<div class="row d-flex justify-content-center align-items-center">
			<div class="col-12 h3 font-weight-bold">
				<span>Utolsó rendelés:</span>
			</div>
			<div class="col-6 h6">
				<span>Rögzítve: {{datum}} |</span> {{datum | day}}
			</div>
			<div class="col-6 h6">
				<span>Kiszállítási dátum: {{kidatum}} |</span> {{kidatum | day}}
			</div>
			<div class="col-12">
				<div class="row d-flex justify-content-center">
					<div
						class="col-12"
						v-for="(item_last,index) in lastorder"
						:key="`last-${index}`"
					>
						<orderitem
							:tszam="item_last.tszam"
							:nev="item_last.nev"
							:ar="item_last.ar"
							:db="item_last.db"
							:lastorder="true"
							:lastmegj="item_last.rendmegj"
							:copyComment="true"
						/>
						</orderitem>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import orderitem from './order_item'
export default {
	name: 'lastorder',

	props: ['customer'],

	components: {
		orderitem
	},

	data() {
		return {
			lastorder: []
		}
	},

	mounted(){
		this.$Progress.start()
		this.req.post(`orders/lastorder/${this.customer}`)
			.then(res => {
				this.lastorder = res.data.rend
				this.$Progress.finish()
			})
			.catch(err => {
				console.log(err)
				this.$Progress.fail()
			})
	},

	computed: {
		datum() {
			return this.lastorder[0] != undefined ? this.lastorder[0].datum : null
		},

		kidatum() {
			return this.lastorder[0] != undefined ? this.lastorder[0].kidatum : null
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/lastorder.vue